import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=c8bde8e4&scoped=true&"
import script from "./Placeholder.vue?vue&type=script&lang=ts&"
export * from "./Placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=c8bde8e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bde8e4",
  null
  
)

export default component.exports